<template>
    <product-overview id="DI_overview" title="Group Short Term Disability Insurance" :ctaLink="`/${$route.params.id}/disability-income`">
        <template v-slot:video>
            <a-video />
        </template>
        <p><strong>Short-Term Disability Income insurance pays a weekly benefit directly to you</strong> if you are sick or injured and can’t work.</p>
        <template v-slot:key-features>
            <key-feature-bullet>
                Pays benefits if you become totally disabled and can’t perform the important duties of your occupation, as long as you are not working another job and are under the care of a physician 
            </key-feature-bullet>
            <key-feature-bullet>
                Weekly benefit of {{getMinBenefit()}} to {{getMaxBenefit()}}, subject to maximum benefit
            </key-feature-bullet>
        </template>
    </product-overview>
</template>
<script>
import { mapGetters } from 'vuex'
import { currency } from '@/lib'
import  { DisabilityIncomeVideo as AVideo } from '@/components/videos'
import ProductOverview from '@/components/product-overviews/product-overview'
import KeyFeatureBullet from '@/components/key-feature-bullet'

export default {
    components: {
        AVideo,
        ProductOverview,
        KeyFeatureBullet
    },
    computed: {

        ...mapGetters({
            product: 'getDisabilityIncome',
            proposalId: 'getProposalId'
        })    
    },
    methods: {
        getBenefitAmount(value, defaultValue) {
            return value ? currency.format.USD(currency.format.number(value)) : defaultValue
        },
        getMinBenefit(){
            const DIWeeklyBenefitDisplay = this.product['DIWeeklyBenefitDisplay.GMC']
            if(DIWeeklyBenefitDisplay === 'Custom') {
                return currency.format.USD(this.product['DIWeeklyBenefitCustomMin.GMC'])
            } else {
                const DIMinWeeklyBenefit = this.product['DIWeeklyBenefitDisplay.GMC'].split('$')[1].replace(/D/g, '')
                return this.product['DIWeeklyBenefitCustomMin.GMC'] ? currency.format.USD(this.product['DIWeeklyBenefitCustomMin.GMC']) : currency.format.USD(DIMinWeeklyBenefit)    
            }
        },
        getMaxBenefit(){
            const DIWeeklyBenefitDisplay = this.product['DIWeeklyBenefitDisplay.GMC']
            if(DIWeeklyBenefitDisplay === 'Custom') {
                return currency.format.USD(this.product['DIWeeklyBenefitCustomMax.GMC'])
            } else {
                const DIMaxWeeklyBenefit = this.product['DIWeeklyBenefitDisplay.GMC'].split('$')[2].replace(/D/g, '')
                return this.product['DIWeeklyBenefitCustomMax.GMC'] ? currency.format.USD(this.product['DIWeeklyBenefitCustomMax.GMC']) : currency.format.USD(DIMaxWeeklyBenefit)
            }
        },
    }
}
</script>
